// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"987":"d9534a08","3663":"d9534a08","8440":"d9534a08"}[chunkId] + ".chunk.css";
};